export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/theft.99c8243a.svg","height":166,"width":165,"blurWidth":0,"blurHeight":0};